module.exports = __webpack_public_path__ + "media/什么是三角形的勾股定理.f1c86fdb.mp4";